module.exports = __webpack_public_path__ + "img/54.f23ae0c8.jpg";